var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCubesMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 360,
    viewBox: "0 0 720 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24786_53275)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 143.856,
    height: 144,
    transform: "matrix(-1 0 0 1 575.484 72.0068)",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 71.9281,
    height: 144,
    transform: "matrix(-1 0 0 1 503.496 144)",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 359.64,
    height: 72,
    transform: "matrix(-1 0 0 1 359.641 216)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 503.496,
    y: 72,
    width: 71.9281,
    height: 72,
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 359.641,
    width: 71.9281,
    height: 72,
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 431.57,
    width: 71.9281,
    height: 72,
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 71.9281,
    height: 72,
    transform: "matrix(-1 0 0 1 431.57 216)",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 71.9281,
    height: 72,
    transform: "matrix(-1 0 0 1 287.711 288)",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 71.9281,
    height: 72,
    transform: "matrix(-1 0 0 1 359.641 288)",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 72,
    transform: "matrix(-1 0 0 1 300 288)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 431.568,
    height: 144,
    transform: "matrix(-1 0 0 1 431.57 72)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 359.64,
    height: 72,
    transform: "matrix(-1 0 0 1 359.641 0)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.426,
    y: 72,
    width: 71.9281,
    height: 72,
    fill: "#F5F7FA",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 71.9281,
    height: 72,
    transform: "matrix(-1 0 0 1 719.281 144)",
    fill: "#F5F7FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24786_53275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 360,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 360)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubesMd);
export default __webpack_public_path__ + "static/media/cubesMd.3cc4faf7beff3d99a0fb8b18e9758716.svg";
export { ForwardRef as ReactComponent };